@if (user) {
  <div class="text-xl font-bold mb-2">{{ user.displayName }}</div>
  <div class="flex flex-row gap-1 justify-between place-items-center m-1">
    <span>Arbeitsstunden pro Woche</span>
    <input class="input input-bordered w-24" type="number" min="0" max="80" [(ngModel)]="workingHours" />
  </div>
  <button class="btn btn-primary btn-block" [loadingFn]="saveWorkingHours()">Speichern</button>
}
